import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import App from './App';
import { Overlay } from './Overlay';

// Create the root element once
const rootElement = document.getElementById('root');
const root = createRoot(rootElement); // Only call createRoot once

root.render(
  <>
    <App />
    <Overlay />
  </>
);
